import { Component } from '@angular/core';
import { Login } from './login.model';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { Globals } from '../../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsService } from '../../../services/websocket/WsService';
import { SuperClass } from '../../../superclass/SuperClass';

@Component({
  selector: 'app-login-history',
  templateUrl: './login-history.component.html',
  styleUrls: ['./login-history.component.css'],
})
export class LoginHistoryComponent extends SuperClass {
  loginHistory: Login[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      {
        label: 'Login History',
        routerLink: [{ outlets: { sub: [RouterConst.LOGIN_HISTORY] } }],
      },
    ]);
  }

  getDate(date) {
    return new Date(date);
  }

  reloadData() {
    this.http_getLoginHistory((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.loginHistory = data.payload;
        console.log(this.loginHistory);
      }
    });
  }

  unselectRow() {}

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/login-history/login-history.component.ts